<ion-header class="ion-no-shadow ion-no-border"
            [ngClass]="{'no-border': (!(selectedParticipant || selectedChatGroup || selectedBroadcast) || !plt.tabMenu) && !addChatGroup}">
    <ion-toolbar *ngIf="!loading && (!(selectedParticipant || selectedChatGroup || selectedBroadcast) || plt.sizeSm)"
                 class="ion-hide-xl-up">

        <!-- page switcher  -->
        <ion-title *ngIf="(!(selectedParticipant || selectedChatGroup || selectedBroadcast) || !plt.tabMenu) && !addChatGroup"
                   class="full">
            <div class="btn-submenu">
                <button type="button"
                        (click)="selectPage('messages')"
                        [ngClass]="{ 'active' : selectedPage == 'messages' }">
                    <span>
                        {{ 'MESSAGES_HEADER_MOBILE' | translate }}
                        <ion-badge *ngIf="plt.unreadMessages || plt.unreadChatGroups"
                                   class="notification">
                            {{ plt.unreadMessages + plt.unreadChatGroups }}
                        </ion-badge>
                    </span>
                </button>
                <button type="button"
                        (click)="selectPage('notifications')"
                        [ngClass]="{ 'active' : selectedPage == 'notifications' }">
                    <span>
                        {{ 'NOTIFICATIONS_HEADER_MOBILE' | translate }}
                        <ion-badge *ngIf="plt.unreadNotifications"
                                   class="notification">
                            {{ plt.unreadNotifications }}
                        </ion-badge>
                    </span>
                </button>
            </div>
        </ion-title>

        <ion-title *ngIf="(selectedParticipant || selectedChatGroup || selectedBroadcast || addChatGroup) && plt.tabMenu"
                   class="full"
                   [ngClass]="{
                    'item-title': !addChatGroup && !selectedChatGroup?.stream,
                    'broadcast': selectedBroadcast, 'back-button': (selectedChatGroup?.stream && selectedChatGroup.stream.display_chat) || videoCallOpened,
                    'two-buttons-right': selectedChatGroup?.user_is_owner || ((selectedParticipant && user?.canVideoCall(selectedParticipant)) || (selectedChatGroup && selectedChatGroup.callIsAllowed() )),
                    'three-buttons-right': selectedChatGroup?.user_is_owner && ((selectedParticipant && user?.canVideoCall(selectedParticipant)) || (selectedChatGroup && selectedChatGroup.callIsAllowed() ))
                }">
            <ng-container *ngIf="selectedParticipant">
                <ng-container *ngIf="selectedParticipant.id">
                    <a (click)="showAttendeeDetail(selectedParticipant, false)"
                       class="pointer">
                        {{ selectedParticipant.getFullName() }}
                    </a>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="selectedBroadcast">{{ event.name }}</ng-container>
            <ng-container *ngIf="selectedChatGroup">
                <svg-icon [applyClass]="true"
                          src="/assets/icons/ico-hashtag.svg"
                          class="icon hashtag fill-dark"></svg-icon>
                {{ selectedChatGroup.name }}
            </ng-container>
            <ng-container *ngIf="addChatGroup">
                {{ 'CHAT_GROUPS_CHANNELS' | translate }}
            </ng-container>
        </ion-title>

        <ng-container *ngIf="plt.tabMenu">
            <a *ngIf="(selectedParticipant || selectedChatGroup || selectedBroadcast || addChatGroup) && plt.tabMenu && !videoCallOpened && !external"
               (click)="selectedChatGroup?.stream ? (chatVisible ? disableSideboxes() : goToDashboard()) : (detailVisible ? disableSideboxes() : resetDetail())"
               class="back-link">
                <svg-icon [applyClass]="true"
                          src="/assets/icons/ico-arrow.svg">
                </svg-icon>

            </a>
        </ng-container>

        <ion-buttons *ngIf="(selectedParticipant || selectedChatGroup || selectedBroadcast) && plt.sizeSm"
                     slot="end">
            <ng-container *ngIf="!selectedChatGroup?.stream">
                <ion-button *ngIf="selectedChatGroup?.user_is_owner"
                            (click)="editChatGroup()"
                            class="edit-chatgroup">
                    <svg-icon [applyClass]="true"
                              src="/assets/icons/ico-settings.svg"
                              class="icon fill-light">
                    </svg-icon>
                </ion-button>
                <ion-button *ngIf="!videoCallOpened && ((selectedParticipant && user?.canVideoCall(selectedParticipant)) || (selectedChatGroup && selectedChatGroup.callIsAllowed() ))"
                            (click)="openVideoCall()"
                            class="video-call">
                    <ion-icon name="videocam-outline">
                    </ion-icon>
                </ion-button>
                <ion-button (click)="toggleDetail()"
                            class="toggle-detail">
                    <svg-icon [applyClass]="true"
                              src="/assets/icons/ico-eventinfo.svg"
                              [ngClass]="{'fill-dark': detailVisible, 'fill-medium': !detailVisible}"
                              class="icon">
                    </svg-icon>
                </ion-button>
            </ng-container>
            <ion-button *ngIf="(selectedChatGroup?.stream && selectedChatGroup.stream.display_chat) || videoCallOpened"
                        (click)="toggleChat()"
                        class="toggle-chat">
                <svg-icon [applyClass]="true"
                          src="/assets/icons/ico-messages.svg"
                          [ngClass]="{'fill-dark': chatVisible, 'fill-medium': !chatVisible}"
                          class="icon">
                </svg-icon>
                <ion-badge *ngIf="unreadCount"
                           class="unread-count">{{unreadCount}}
                </ion-badge>
            </ion-button>
        </ion-buttons>

    </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">

    <header-notifications *ngIf="(selectedParticipant || selectedChatGroup || selectedBroadcast) || !plt.tabMenu"
                          [chatView]="true"
                          [callView]="videoCallOpened"
                          [streamView]="selectedChatGroup?.stream"
                          [detailVisible]="detailVisible"
                          class="chat-view">]
    </header-notifications>

    <div class="content-box"
         *ngIf="selectedPage == 'notifications' && user.id && event">

        <h1 [innerHTML]="'MESSAGES_HEADER' | translate : {event: event?.translate(event?.default_locale).name}"></h1>

        <div class="content-box-inner">

            <div class="content-data with-header">

                <app-notifications [isModal]="false"
                                   [event]="event">
                </app-notifications>

            </div>

        </div>

    </div>

    <ion-refresher *ngIf="selectedPage == 'messages' && !videoCallOpened && (!plt.tabMenu || (!(selectedParticipant || selectedChatGroup || selectedBroadcast) && selectedPage == 'messages' && !addChatGroup))"
                   pullMin="250"
                   (ionRefresh)="refresh($event)"
                   slot="fixed">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>

    <app-add-chat-group *ngIf="addChatGroup"></app-add-chat-group>

    <app-chat-groups-list *ngIf="plt.tabMenu"
                          #chatGroupList
                          [external]="external"
                          [ngClass]="{'visible': !loading && !(selectedParticipant || selectedChatGroup || selectedBroadcast) && selectedPage == 'messages' && !addChatGroup}">
    </app-chat-groups-list>

    <ng-container *ngIf="selectedPage == 'messages'">
        <div *ngIf="!loading && event && user && (selectedParticipant || selectedBroadcast || selectedChatGroup) && !addChatGroup"
             class="message-box"
             [ngClass]="{'bottom-menu': selectedBroadcast, 'top-menu': plt.tabMenuOnTop}">

            <div class="messages"
                 [ngClass]="{'detail-enabled': detailVisible}">

                <div *ngIf="(selectedParticipant || selectedBroadcast || selectedChatGroup) || !plt.sizeSm"
                     class="chat-box">

                    <div *ngIf="!plt.sizeSm"
                         class="chat-box-header">
                        <ion-row class="ion-no-padding ion-align-items-center">
                            <ion-col size="1"
                                     *ngIf="(selectedParticipant || selectedChatGroup || selectedBroadcast || addChatGroup) && plt.tabMenu && !external"
                                     class="ion-no-padding">
                                <a (click)="resetDetail()"
                                   class="back-link">
                                    <svg-icon [applyClass]="true"
                                              src="/assets/icons/ico-arrow.svg">
                                    </svg-icon>
                                </a>
                            </ion-col>
                            <ion-col *ngIf="!plt.sizeSm"
                                     class="ion-no-padding"
                                     size="7">
                                <h2
                                    [ngClass]="{'longer-text': plt.sizeMd && ((selectedBroadcast && event.name.length > 28) || (selectedChatGroup && selectedChatGroup.translate(userLang, event.default_locale).name.length > 38))}">
                                    <ng-container *ngIf="selectedParticipant">
                                        <ng-container *ngIf="selectedParticipant.id">
                                            <a (click)="showAttendeeDetail(selectedParticipant, false)"
                                               class="pointer">
                                                {{ selectedParticipant.getFullName() }}
                                            </a>
                                        </ng-container>
                                        <ng-container *ngIf="!selectedParticipant.id">
                                            <ion-skeleton-text animated
                                                               style="width: 50%"></ion-skeleton-text>
                                        </ng-container>
                                    </ng-container>
                                    <ng-container *ngIf="selectedBroadcast">{{ event.name }}</ng-container>
                                    <ng-container *ngIf="selectedChatGroup">
                                        <svg-icon [applyClass]="true"
                                                  src="/assets/icons/ico-hashtag.svg"
                                                  class="icon hashtag fill-light"></svg-icon>
                                        {{ selectedChatGroup.translate(userLang, event.default_locale).name }}
                                    </ng-container>
                                </h2>
                                <h3 *ngIf="selectedChatGroup && !selectedChatGroup.stream"
                                    class="member-count">
                                    <svg-icon [applyClass]="true"
                                              src="/assets/icons/ico-attendee.svg"
                                              class="icon hashtag fill-light"></svg-icon>
                                    {{ selectedChatGroup.number_attendees }}
                                </h3>
                            </ion-col>
                            <ion-col class="flex ion-justify-content-end ion-align-items-center ion-no-padding">

                                <ion-item *ngIf="selectedChatGroup?.stream"
                                          (click)="goToDashboard()"
                                          class="back-link">
                                    <ion-label *ngIf="event?.is_homepage_content_stream">{{ 'STREAM_BACK_TO_LIST' | trns }}</ion-label>
                                </ion-item>

                                <ng-container *ngIf="!selectedChatGroup?.stream">
                                    <ion-searchbar *ngIf="!plt.sizeMs"
                                                   [placeholder]="'MESSAGES_SEARCH_PLACEHOLDER' | translate"
                                                   class="without-border"
                                                   style="padding: 0;"
                                                   [debounce]="500"
                                                   enterkeyhint="search"
                                                   [(ngModel)]="searchMessage"
                                                   (onenter)="refresh()"
                                                   (ionChange)="refresh(null, false)">
                                    </ion-searchbar>
                                    <ion-button *ngIf="selectedChatGroup?.user_is_owner"
                                                (click)="editChatGroup()"
                                                class="edit-chatgroup">
                                        <svg-icon [applyClass]="true"
                                                  src="/assets/icons/ico-settings.svg"
                                                  class="icon fill-light">
                                        </svg-icon>
                                    </ion-button>
                                    <ion-button *ngIf="!videoCallOpened && ((selectedParticipant && user?.canVideoCall(selectedParticipant)) || (selectedChatGroup && selectedChatGroup.callIsAllowed() && !user.selected_participant.invisible))"
                                                (click)="openVideoCall()"
                                                class="video-call">
                                        <ion-icon name="videocam-outline">
                                        </ion-icon>
                                    </ion-button>
                                    <ion-button (click)="toggleDetail()"
                                                class="toggle-detail">
                                        <svg-icon [applyClass]="true"
                                                  src="/assets/icons/ico-eventinfo.svg"
                                                  class="icon fill-dark">
                                        </svg-icon>
                                    </ion-button>
                                </ng-container>

                            </ion-col>
                        </ion-row>
                    </div>

                    <span class="overlay-loading"
                          [ngClass]="{enabled: loadingConversation && !videoCallOpened && !selectedChatGroup?.stream, 'keep-header': searchMessage}">
                        <ion-spinner></ion-spinner>
                    </span>

                    <div class="chat-box-content">

                        <div *ngIf="selectedChatGroup?.stream"
                             class="stream-wrapper"
                             [ngClass]="{'chat-visible': chatVisible}">
                            <iframe *ngIf="selectedChatGroup.stream?.embed_link"
                                    [src]="selectedChatGroup.stream?.embed_link | safe:'resourceUrl'"
                                    frameborder="0"
                                    allowfullscreen>
                            </iframe>
                        </div>

                        <chime *ngIf="videoCallOpened"
                               [ngClass]="{'chat-visible': chatVisible}"
                               [participant]="selectedParticipant"
                               [chatGroup]="selectedChatGroup"
                               [chatGroupAttendees]="chatGroupAttendees"
                               [external]="external"
                               [muteOnStart]="selectedChatGroup && event.allow_call_chat_group_mute"
                               (onCanceled)="closeVideoCall()"
                               (onLoaded)="refresh()">
                        </chime>

                        <div *ngIf="(!selectedChatGroup?.stream || selectedChatGroup.stream.display_chat)">
                            <div #chatBox
                                 [ngClass]="{'no-form': selectedBroadcast, 'no-appointments': (selectedParticipant && event.disable_appointments) || (selectedChatGroup && plt.sizeSm), 'tabs-visible': plt.tabMenuOnTop }"
                                 class="chat-box-list"
                                 infiniteScroll
                                 [infiniteScrollDisabled]="loadingInfinite"
                                 [infiniteScrollDistance]="2"
                                 [infiniteScrollUpDistance]="2.5"
                                 [infiniteScrollThrottle]="150"
                                 [scrollWindow]="false"
                                 [alwaysCallback]="true"
                                 (scrolledUp)="onScrollUp()">

                                <ng-container *ngIf="selectedBroadcast">
                                    <div *ngFor="let broadcast of broadcasts">

                                        <div *ngIf="broadcast && broadcast.firstNew"
                                             class="delimiter">
                                            <hr />
                                            <h3>{{ 'MESSAGES_NEW_MESSAGE_SUBHEADER' | translate}}</h3>
                                        </div>

                                        <div class="chat-message left system">
                                            <ion-avatar *ngIf="!plt.sizeSm"
                                                        class="small-radius">
                                                <ion-skeleton-text animated></ion-skeleton-text>
                                                <img class="message-logo"
                                                     img-logo
                                                     [src]="event.logo_url"
                                                     [alt]="event.name">
                                            </ion-avatar>
                                            <div class="message system broadcast">
                                                <div class="message-content text-left fr-view broadcast-content">
                                                    <ng-container *ngIf="broadcast.translate(userLang, event.default_locale).headerImage">
                                                        <img [src]="plt.createSignedLink(broadcast.translate(userLang, event.default_locale).headerImage)"
                                                             class="header-image" />
                                                    </ng-container>
                                                    <h3>{{ broadcast.translate(userLang, event.default_locale).subject }}</h3>
                                                    <div [innerHtml]="broadcast.translate(userLang, event.default_locale).message | securedImages | linkify | stripMailTags | safe:'html'"></div>
                                                    <ion-button *ngIf="broadcast.chat_group_id && broadcast.pivot?.status == 'invited' && !user.selected_participant.not_contactable && !user.selected_participant.invisible"
                                                                (click)="joinChatGroup(broadcast.chat_group_id)">
                                                        {{ 'CHAT_GROUPS_JOIN' | translate }}
                                                    </ion-button>
                                                    <div class="atttachments">
                                                        <ng-container *ngFor="let file of broadcast.files">
                                                            <file-detail *ngIf="file.file_url"
                                                                         [file]="file">
                                                            </file-detail>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                                <span class="message-date">
                                                    {{ broadcast.date_sent_at | datex }} {{ broadcast.date_sent_at | datex:'timeFormatDefault' }}
                                                    |
                                                    <strong class="message-author">
                                                        {{ broadcast.translate(userLang, event.default_locale).sender_name }}
                                                    </strong>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="end"></div>
                                </ng-container>

                                <ng-container *ngIf="selectedParticipant && conversation">
                                    <div *ngFor="let message of conversation.messages; let i = index">

                                        <div *ngIf="i == 0 || (i > 0 && message && message.day != conversation.messages[i - 1].day)"
                                             class="delimiter date">
                                            <hr />
                                            <h3>{{ message.date_created_at | datex }}</h3>
                                        </div>

                                        <div *ngIf="message && message.firstNew"
                                             class="delimiter new-message-header">
                                            <hr />
                                            <h3>{{ 'MESSAGES_NEW_MESSAGE_SUBHEADER' | translate}}</h3>
                                        </div>

                                        <ng-container *ngIf="!!message.system_message && ['LINKED_ITEM'].indexOf(message.system_message) == -1">
                                            <ng-container *ngIf="['CHAT_GROUP_INVITATION', 'CHAT_GROUP_INVITATION_CANCELED', 'CHAT_GROUP_INVITATION_ACCEPTED'].indexOf(message.system_message) == -1">
                                                <div class="chat-message left system">
                                                    <ion-avatar class="small-radius">
                                                        <ion-skeleton-text animated></ion-skeleton-text>
                                                        <img class="message-logo"
                                                             img-logo
                                                             [src]="event.logo_url"
                                                             [alt]="event.name">
                                                    </ion-avatar>
                                                    <div class="message system">
                                                        <span *ngIf="!message.appointment"
                                                              class="message-content dont-break-out dont-break-out">{{ message.system_message | translate }}</span>
                                                        <span *ngIf="message.appointment && user.selected_participant.event.use_timeslots"
                                                              class="message-content dont-break-out dont-break-out">
                                                            {{ message.system_message | translate: {date: (message.appointment.date_starts_at | datex) + ' ' + (message.appointment.date_starts_at |
                                                            datex:'timeFormatDefault') + ' - ' + (message.appointment.date_ends_at | datex:'timeFormatDefaultEnd' : '' )} }}</span>
                                                        <span *ngIf="message.appointment && !user.selected_participant.event.use_timeslots"
                                                              class="message-content dont-break-out dont-break-out">
                                                            {{ message.system_message | translate: {date: (message.appointment.date_starts_at | datex) + ' ' + (message.appointment.date_starts_at |
                                                            datex:'timeFormatDefault')} }}</span>
                                                        <span class="message-date">
                                                            {{ message.date_created_at | datex }} {{ message.date_created_at | datex:'timeFormatDefault' }}
                                                            |
                                                            <strong class="message-author">{{ 'SYSTEM_MESSAGE' | translate }}</strong>
                                                        </span>
                                                    </div>
                                                </div>
                                            </ng-container>

                                            <!-- chat group invitation -->
                                            <ng-container *ngIf="['CHAT_GROUP_INVITATION', 'CHAT_GROUP_INVITATION_CANCELED', 'CHAT_GROUP_INVITATION_ACCEPTED'].indexOf(message.system_message) >= 0">
                                                <div class="chat-message system chat-group-invitation"
                                                     [ngClass]="{'left': message.participant_id != user.selected_participant_id, 'right': message.participant_id == user.selected_participant_id}">

                                                    <ion-avatar *ngIf="message.participant_id == selectedParticipant.id">
                                                        <ion-skeleton-text animated></ion-skeleton-text>
                                                        <img (click)="showAttendeeDetail(selectedParticipant, false)"
                                                             [ngClass]="user.canProfileDetails(selectedParticipant) ? 'pointer' : ''"
                                                             class="message-avatar"
                                                             img-avatar
                                                             [src]="user?.canPicture(selectedParticipant) ? selectedParticipant.picture_url : ''"
                                                             alt="">
                                                    </ion-avatar>

                                                    <ion-avatar *ngIf="message.participant_id == user.selected_participant_id"
                                                                class="small-radius">
                                                        <ion-skeleton-text animated></ion-skeleton-text>
                                                        <img class="message-avatar"
                                                             img-avatar
                                                             [src]="user.selected_participant?.picture_url"
                                                             alt="">
                                                    </ion-avatar>

                                                    <div class="message system">
                                                        <span class="message-date">
                                                            <strong class="message-author"
                                                                    *ngIf="message.participant_id == selectedParticipant.id">{{ selectedParticipant.getFullName() | cut: 42:'... ':false }}</strong>
                                                            <strong class="message-author"
                                                                    *ngIf="message.participant_id == user.selected_participant.id">{{ user.selected_participant.getFullName() | cut: 42:'... ':false
                                                                }}</strong>
                                                            {{ message.date_created_at | datex:'timeFormatDefaultEnd' }}
                                                        </span>

                                                        <div class="message-content dont-break-out dont-break-out">
                                                            <h3>{{ 'CHAT_GROUP_INVITATION_TITLE' | translate }}</h3>
                                                            <div>{{ 'CHAT_GROUP_INVITATION' | translate: {'chat_group_name': message.message} }}</div>
                                                            <ion-button *ngIf="message.system_message == 'CHAT_GROUP_INVITATION' && user.selected_participant_id != message.participant_id && !user.selected_participant.not_contactable && !user.selected_participant.invisible"
                                                                        (click)="joinChatGroup(message.chat_group_id)">
                                                                {{ 'CHAT_GROUPS_JOIN' | translate }}
                                                            </ion-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-container>

                                        </ng-container>

                                        <edit-message *ngIf="message.edit"
                                                      [message]="message"
                                                      [conversationId]="conversation.id"
                                                      (onSended)="messageSended($event)"
                                                      (onCanceled)="messageEditationCanceled($event)">
                                        </edit-message>

                                        <div *ngIf="!message.edit && !message.system_message && selectedParticipant.id !== message.participant_id"
                                             class="chat-message right"
                                             [ngClass]="{'deleted': message.deleted_at}">

                                            <ion-avatar>
                                                <ion-skeleton-text animated></ion-skeleton-text>
                                                <img class="message-avatar"
                                                     img-avatar
                                                     [src]="user.selected_participant?.picture_url"
                                                     alt="">
                                            </ion-avatar>
                                            <div class="message">

                                                <span class="message-date"
                                                      [ngClass]="{'buttons': message.active}">
                                                    <div *ngIf="(user?.selected_participant?.id == message.participant_id) &&
                                                                !message.deleted_at &&
                                                                !message.appointment &&
                                                                (!selectedParticipant.invisible && !user.selected_participant.invisible)"
                                                         class="action-buttons"
                                                         [ngClass]="{'active': message.active}">
                                                        <svg-icon [applyClass]="true"
                                                                  src="/assets/icons/ico-close.svg"
                                                                  class="remove"
                                                                  (click)="openDestroyMessage(message)">
                                                        </svg-icon>
                                                        <svg-icon [applyClass]="true"
                                                                  src="/assets/icons/ico-edit.svg"
                                                                  class="edit"
                                                                  (click)="editMessage(message)">
                                                        </svg-icon>
                                                    </div>

                                                    <span>
                                                        <strong class="message-author">
                                                            {{ user.selected_participant?.getFullName() | cut: 42:'... ':false }}
                                                        </strong>
                                                        <ng-container *ngIf="message.deleted_at"> ({{ 'CONVERSATION_MESSAGE_DELETED' | translate }}) </ng-container>
                                                        <ng-container *ngIf="!message.deleted_at && (message.updated_at && (message.created_at != message.updated_at))"> ({{ 'MESSAGE_EDITED' |
                                                            translate
                                                            }}) </ng-container>
                                                        {{ message.date_created_at | datex:'timeFormatDefaultEnd' }}
                                                    </span>
                                                </span>

                                                <ng-container *ngIf="(message.message || message.linkedItem) && !message.appointment && !message.deleted_at">
                                                    <span (click)="message.active = !message.active"
                                                          class="message-content dont-break-out">
                                                        <ng-container *ngIf="message.linkedItem">
                                                            <ng-container [ngSwitch]="true">
                                                                <ng-container *ngSwitchCase="message.linkedItem.type == 'marketplace-post'">
                                                                    <h3 [ngClass]="{'clickable': message.linkedItem.clickable}"
                                                                        (click)="showMarketplacePostDetailFromLinked(message.linkedItem)">{{ 'MARKETPLACE_POST_REFERENCE_SUBJECT_PREFIX' | translate}}
                                                                        {{ message.linkedItem.text }}
                                                                    </h3>
                                                                </ng-container>
                                                            </ng-container>
                                                        </ng-container>
                                                        <span *ngIf="message.message "
                                                              [innerHtml]="message.message | striphtml:true | linkify | newline | safe:'html'">
                                                        </span>
                                                    </span>
                                                </ng-container>

                                                <file-detail *ngIf="message.file && !message.deleted_at"
                                                             (click)="message.active = !message.active"
                                                             [file]="message.file">
                                                </file-detail>
                                                <!-- END :: Message without appointment -->

                                                <span *ngIf="message.appointment && !message.deleted_at"
                                                      class="message-content message-content--appointment dont-break-out">
                                                    <span class="message-label">{{ 'CONVERSATIONS_APPOINTMENT_REQUEST' | translate }}</span>
                                                    <br /><br />
                                                    <strong>{{ 'APPOINTMENT_REQUEST_WHEN' | translate }}: </strong>
                                                    {{ message.appointment.date_starts_at | datex: 'dateFormatDayName' }}
                                                    <ng-container *ngIf="!message.appointment.date_ends_at">
                                                        {{ message.appointment.date_starts_at | datex: 'timeFormatDefaultEnd' }}
                                                    </ng-container>
                                                    <ng-container *ngIf="message.appointment.date_ends_at">
                                                        {{ message.appointment.date_starts_at | datex: 'timeFormatDefault' }}
                                                        <ng-container *ngIf="message.appointment.date_ends_at">
                                                            - <span [innerHtml]="message.appointment.date_ends_at | datex:'timeFormatDefaultEnd'"></span>
                                                        </ng-container>
                                                    </ng-container>
                                                    <br>
                                                    <strong>{{ 'APPOINTMENT_REQUEST_WHERE' | translate }}: </strong>
                                                    <ng-container *ngIf="message.appointment.online  && (message.appointment.participants?.length <= 2 || message.appointment.participantStatus === 1)">
                                                        <a (click)="openVideoCall(message.appointment)"
                                                           class="pointer">
                                                            {{'ATTENDEE_DETAIL_CALL_START' | translate}}
                                                        </a>
                                                    </ng-container>
                                                    <ng-container *ngIf="!message.appointment.online">{{ message.appointment.location }}</ng-container>
                                                    <ng-container
                                                                  *ngIf="message.appointment.online && message.appointment.participants?.length > 2 && message.appointment.participantStatus !== 1">{{'ATTENDEE_DETAIL_CALL_START'
                                                        | trns}}</ng-container>
                                                    <br>
                                                    <strong>{{ 'APPOINTMENT_REQUEST_WHY' | translate }}: </strong> {{ message.appointment.description }}<br>

                                                    <div *ngIf="message.appointment?.participants?.length >= 3"
                                                         class="participant-list">
                                                        <strong>{{ 'MESSAGES_APPOINTMENT_MEMBERS' | translate }}: </strong>
                                                        <span *ngFor="let participant of message.appointment.participants; let i = index"
                                                              (click)="showAttendeeDetail(participant, false)"
                                                              [ngClass]="user.canProfileDetails(participant) ? 'pointer' : ''">
                                                            <span *ngIf="i > 0">, </span>{{ participant.getFullName() }}
                                                        </span>
                                                    </div>

                                                    <br>
                                                    <a (click)="download(message.appointment)"
                                                       class="appointment-ics"
                                                       *ngIf="message.appointment.participantStatus === 1">
                                                        <svg-icon [applyClass]="true"
                                                                  src="/assets/icons/ico-calendar.svg"
                                                                  class="icon fill-light"></svg-icon>
                                                        {{ 'APPOINTMENT_REQUEST_TOOLTIP_ADD_TO_CALENDAR' | translate }}
                                                    </a>
                                                    <span *ngIf="message.appointment.participantStatus === 0">
                                                        <i class="fa fa-clock-o"></i>
                                                        <span [innerHtml]="'CONVERSATIONS_APPOINTMENT_IS_WAITING' | translate"></span>
                                                    </span>
                                                    <span *ngIf="message.appointment.participantStatus === 1"
                                                          class="appointment-accepted">
                                                        <i class="fa fa-check"></i>
                                                        <span [innerHtml]="'CONVERSATIONS_APPOINTMENT_IS_ACCEPTED' | translate"></span>
                                                    </span>
                                                    <span *ngIf="message.appointment.participantStatus === 2"
                                                          class="appointment-declined">
                                                        <i class="fa fa-times"></i>
                                                        <span [innerHtml]="'CONVERSATIONS_APPOINTMENT_IS_DECLINED' | translate"></span>
                                                    </span>
                                                    <span *ngIf="message.appointment.participantStatus === 3"
                                                          class="appointment-declined">
                                                        <i class="fa fa-times"></i>
                                                        <span [innerHtml]="'CONVERSATIONS_APPOINTMENT_IS_CANCELED' | translate"></span>
                                                    </span>
                                                </span>
                                                <!-- END :: Message with appointment -->

                                            </div>
                                        </div>

                                        <div *ngIf="!message.edit && !message.system_message && selectedParticipant.id === message.participant_id"
                                             class="chat-message left"
                                             [ngClass]="{'message-appointment':message.appointment && !message.deleted_at}">

                                            <ion-avatar>
                                                <ion-skeleton-text animated></ion-skeleton-text>
                                                <img (click)="showAttendeeDetail(selectedParticipant, false)"
                                                     [ngClass]="user.canProfileDetails(selectedParticipant) ? 'pointer' : ''"
                                                     class="message-avatar pointer"
                                                     img-avatar
                                                     [src]="user?.canPicture(selectedParticipant) ? selectedParticipant.picture_url : ''"
                                                     alt="">
                                            </ion-avatar>
                                            <div class="message"
                                                 [ngClass]="{ unread: message.unread }">

                                                <span class="message-date">
                                                    <strong class="message-author"
                                                            href="#">
                                                        {{ selectedParticipant.getFullName() | cut: 42:'... ':false }}
                                                    </strong>
                                                    <ng-container *ngIf="message.deleted_at"> ({{ 'CONVERSATION_MESSAGE_DELETED' | translate }}) </ng-container>
                                                    <ng-container *ngIf="!message.deleted_at && (message.updated_at && (message.created_at != message.updated_at))"> ({{ 'MESSAGE_EDITED' | translate
                                                        }}) </ng-container>
                                                    {{ message.date_created_at | datex:'timeFormatDefaultEnd' }}
                                                </span>

                                                <ng-container *ngIf="(message.message || message.linkedItem) && !message.appointment && !message.deleted_at">
                                                    <span class="message-content dont-break-out">
                                                        <ng-container *ngIf="message.linkedItem">
                                                            <ng-container [ngSwitch]="true">
                                                                <ng-container *ngSwitchCase="message.linkedItem.type == 'marketplace-post'">
                                                                    <h3 [ngClass]="{'clickable': message.linkedItem.clickable}"
                                                                        (click)="showMarketplacePostDetailFromLinked(message.linkedItem)">{{ 'MARKETPLACE_POST_REFERENCE_SUBJECT_PREFIX' | translate}}
                                                                        {{ message.linkedItem.text }}
                                                                    </h3>
                                                                </ng-container>
                                                            </ng-container>
                                                        </ng-container>
                                                        <span *ngIf="message.message "
                                                              [innerHtml]="message.message | striphtml:true | linkify | newline | safe:'html'">
                                                        </span>
                                                    </span>
                                                </ng-container>

                                                <file-detail *ngIf="message.file && !message.deleted_at"
                                                             [file]="message.file">
                                                </file-detail>
                                                <!-- END :: Message without appointment -->

                                                <span *ngIf="message.appointment && !message.deleted_at"
                                                      class="message-content message-content--appointment dont-break-out">
                                                    <span class="message-label">{{ 'CONVERSATIONS_APPOINTMENT_REQUEST' | translate }}</span>
                                                    <br /><br />
                                                    <strong>{{ 'APPOINTMENT_REQUEST_WHEN' | translate }}: </strong>
                                                    {{ message.appointment.date_starts_at | datex: 'dateFormatDayName' }}
                                                    <ng-container *ngIf="!message.appointment.date_ends_at">
                                                        {{ message.appointment.date_starts_at | datex: 'timeFormatDefaultEnd' }}
                                                    </ng-container>
                                                    <ng-container *ngIf="message.appointment.date_ends_at">
                                                        {{ message.appointment.date_starts_at | datex: 'timeFormatDefault' }} - <span
                                                              [innerHtml]="message.appointment.date_ends_at | datex:'timeFormatDefaultEnd'"></span>
                                                    </ng-container>
                                                    <br>
                                                    <strong>{{ 'APPOINTMENT_REQUEST_WHERE' | translate }}: </strong>
                                                    <ng-container *ngIf="message.appointment.online  && (message.appointment.participants?.length <= 2 || message.appointment.participantStatus === 1)">
                                                        <a (click)="openVideoCall(message.appointment)"
                                                           class="pointer">
                                                            {{'ATTENDEE_DETAIL_CALL_START' | translate}}
                                                        </a>
                                                    </ng-container>
                                                    <ng-container *ngIf="!message.appointment.online">{{ message.appointment.location }}</ng-container>
                                                    <ng-container
                                                                  *ngIf="message.appointment.online && message.appointment.participants?.length > 2 && message.appointment.participantStatus !== 1">{{'ATTENDEE_DETAIL_CALL_START'
                                                        | trns}}</ng-container>
                                                    <br>
                                                    <strong>{{ 'APPOINTMENT_REQUEST_WHY' | translate }}: </strong> {{ message.appointment.description }}<br>

                                                    <div *ngIf="message.appointment?.participants?.length >= 3"
                                                         class="participant-list">
                                                        <strong>{{ 'MESSAGES_APPOINTMENT_MEMBERS' | translate }}: </strong>
                                                        <span *ngFor="let participant of message.appointment.participants; let i = index"
                                                              (click)="showAttendeeDetail(participant, false)"
                                                              [ngClass]="user.canProfileDetails(participant) ? 'pointer' : ''">
                                                            <span *ngIf="i > 0">, </span>{{ participant.getFullName() }}
                                                        </span>
                                                    </div>

                                                    <br>
                                                    <a (click)="download(message.appointment)"
                                                       class="appointment-ics pointer"
                                                       *ngIf="message.appointment.participantStatus === 1">
                                                        <svg-icon [applyClass]="true"
                                                                  src="/assets/icons/ico-calendar.svg"
                                                                  class="icon fill-light"></svg-icon>
                                                        {{ 'APPOINTMENT_REQUEST_TOOLTIP_ADD_TO_CALENDAR' | translate }}
                                                    </a>
                                                    <div *ngIf="message.appointment.participantStatus === 0"
                                                         class="ion-justify-content-center flex">
                                                        <ion-item>
                                                            <ion-checkbox id="send_acceptation_copy_{{ message.id }}"
                                                                          slot="start"
                                                                          [(ngModel)]="message.appointment.send_acceptation_copy"></ion-checkbox>
                                                            <label for="send_acceptation_copy_{{ message.id }}">{{ 'APPOINTMENT_SEND_ACCEPTATION_COPY' | translate }}</label>
                                                        </ion-item>
                                                    </div>
                                                    <span *ngIf="!loadingConversation && message.appointment.participantStatus === 0"
                                                          class="buttons">
                                                        <ion-button [class]="'cancel lang-' + userLang"
                                                                    (click)="answerAppointment(message.appointment, 2)">
                                                            {{ 'BUTTON_DECLINE' | translate }}
                                                        </ion-button>
                                                        <ion-button [class]="'lang-' + userLang"
                                                                    (click)="answerAppointment(message.appointment, 1)">
                                                            {{ 'BUTTON_ACCEPT' | translate }}
                                                        </ion-button>
                                                    </span>
                                                    <span *ngIf="loadingConversation && message.appointment.participantStatus === 0"
                                                          class="buttons">
                                                        <ion-spinner name="dots"></ion-spinner>
                                                    </span>
                                                    <span *ngIf="message.appointment.participantStatus === 1"
                                                          class="appointment-accepted">
                                                        <i class="fa fa-check"></i>
                                                        <span [innerHtml]="'CONVERSATIONS_APPOINTMENT_YOU_ACCEPTED' | translate"></span>
                                                    </span>
                                                    <span *ngIf="message.appointment.participantStatus === 2"
                                                          class="appointment-declined">
                                                        <i class="fa fa-times"></i>
                                                        <span [innerHtml]="'CONVERSATIONS_APPOINTMENT_YOU_DECLINED' | translate"></span>
                                                    </span>
                                                    <span *ngIf="message.appointment.participantStatus === 3"
                                                          class="appointment-declined">
                                                        <i class="fa fa-times"></i>
                                                        <span [innerHtml]="'CONVERSATIONS_APPOINTMENT_YOU_CANCELED' | translate"></span>
                                                    </span>

                                                </span>
                                                <!-- END :: Message with appointment -->

                                            </div>

                                        </div>

                                    </div>
                                    <div class="end"></div>
                                </ng-container>

                                <ng-container *ngIf="selectedChatGroup">
                                    <header-notifications *ngIf="selectedChatGroup && !(videoCallOpened && detailVisible)"
                                                          [chatGroupLiveVoting]="true"
                                                          class="voting-banner"
                                                          [ngClass]="{'small': videoCallOpened}"
                                                          [selectedChatGroup]="selectedChatGroup">
                                    </header-notifications>

                                    <div *ngFor="let message of messages; let i = index">

                                        <div *ngIf="i == 0 || (i > 0 && message && message.day != messages[i - 1].day)"
                                             class="delimiter date">
                                            <hr />
                                            <h3>{{ message.date_created_at | datex }}</h3>
                                        </div>

                                        <div *ngIf="message && message.firstNew"
                                             class="delimiter new-message-header">
                                            <hr />
                                            <h3>{{ 'MESSAGES_NEW_MESSAGE_SUBHEADER' | translate}}</h3>
                                        </div>

                                        <edit-message *ngIf="message.edit"
                                                      [message]="message"
                                                      (onSended)="messageSended($event)"
                                                      (onCanceled)="messageEditationCanceled($event)">
                                        </edit-message>

                                        <div *ngIf="!message.edit"
                                             class="chat-message"
                                             [ngClass]="{'left': user.selected_participant_id !== message.participant_id, 'right': user.selected_participant_id === message.participant_id}">

                                            <ng-container *ngIf="message.participant">
                                                <ion-avatar>
                                                    <ion-skeleton-text animated></ion-skeleton-text>
                                                    <img (click)="showAttendeeDetail(message.participant, false)"
                                                         [ngClass]="user.canProfileDetails(message.participant) ? 'pointer' : ''"
                                                         class="message-avatar pointer"
                                                         img-avatar
                                                         [src]="user?.canPicture(message.participant) ? message.participant.picture_url : ''"
                                                         alt="{{ message.participant.firstname }} {{ message.participant.lastname }}">
                                                </ion-avatar>

                                                <ion-chip *ngIf="message.participant.is_moderator"
                                                          class="role moderator">
                                                    <ion-label>{{ 'CHAT_GROUP_ROLE_MODERATOR' | translate }}</ion-label>
                                                </ion-chip>

                                                <ion-chip *ngIf="message.participant.is_owner"
                                                          class="role owner">
                                                    <ion-label>{{ 'CHAT_GROUP_ROLE_OWNER' | translate }}</ion-label>
                                                </ion-chip>
                                            </ng-container>

                                            <ion-avatar *ngIf="!message.participant">
                                                <ion-skeleton-text animated></ion-skeleton-text>
                                                <img class="message-avatar pointer"
                                                     img-avatar
                                                     [src]="''"
                                                     alt="">
                                            </ion-avatar>


                                            <div class="message"
                                                 [ngClass]="{ unread: message.unread }">

                                                <span class="message-date"
                                                      [ngClass]="{'buttons': message.active}">

                                                    <ng-cotainer *ngIf="user.selected_participant_id !== message.participant_id">
                                                        <span>
                                                            <strong class="message-author"
                                                                    href="#">
                                                                <ng-container *ngIf="message.participant">
                                                                    {{ message.participant.getFullName() | cut: 42:'... ':false }}
                                                                </ng-container>
                                                                <ng-container *ngIf="!message.participant">
                                                                    {{ 'CHAT_GROUP_UNKNOW_SENDER' | translate }}
                                                                </ng-container>
                                                            </strong>
                                                            <ng-container *ngIf="message.deleted_at"> ({{ 'CONVERSATION_MESSAGE_DELETED' | translate }}) </ng-container>
                                                            <ng-container *ngIf="!message.deleted_at && (message.updated_at && (message.created_at != message.updated_at))"> ({{ 'MESSAGE_EDITED' |
                                                                translate }}) </ng-container>
                                                            {{ message.date_created_at | datex:'timeFormatDefaultEnd' }}
                                                        </span>
                                                    </ng-cotainer>

                                                    <div class="action-buttons-wrapper">
                                                        <div *ngIf="(user?.selected_participant?.id == message.participant_id) && !message.deleted_at && !message.linkedItem"
                                                             class="action-buttons"
                                                             [ngClass]="{'active': message.active}">
                                                            <svg-icon [applyClass]="true"
                                                                      src="/assets/icons/ico-close.svg"
                                                                      class="remove"
                                                                      (click)="openDestroyMessage(message)">
                                                            </svg-icon>
                                                            <svg-icon [applyClass]="true"
                                                                      src="/assets/icons/ico-edit.svg"
                                                                      class="edit"
                                                                      (click)="editMessage(message)">
                                                            </svg-icon>
                                                        </div>

                                                        <div *ngIf="((user?.selected_participant?.id != message.participant_id || message.linkedItem) && (selectedChatGroup.user_is_owner || selectedChatGroup.user_is_moderator)) && !message.deleted_at"
                                                             class="action-buttons"
                                                             [ngClass]="{'active': message.active}">
                                                            <svg-icon [applyClass]="true"
                                                                      src="/assets/icons/ico-close.svg"
                                                                      class="remove"
                                                                      (click)="openDestroyMessage(message)">
                                                            </svg-icon>
                                                        </div>
                                                    </div>

                                                    <ng-container *ngIf="user.selected_participant_id === message.participant_id">
                                                        <span>
                                                            <strong class="message-author"
                                                                    href="#">
                                                                <ng-container *ngIf="message.participant">
                                                                    {{ message.participant.getFullName() | cut: 42:'... ':false }}
                                                                </ng-container>
                                                                <ng-container *ngIf="!message.participant">
                                                                    {{ 'CHAT_GROUP_UNKNOW_SENDER' | translate }}
                                                                </ng-container>
                                                            </strong>
                                                            <ng-container *ngIf="message.deleted_at"> ({{ 'CONVERSATION_MESSAGE_DELETED' | translate }}) </ng-container>
                                                            <ng-container *ngIf="!message.deleted_at && (message.updated_at && (message.created_at != message.updated_at))"> ({{ 'MESSAGE_EDITED' |
                                                                translate }}) </ng-container>
                                                            {{ message.date_created_at | datex:'timeFormatDefaultEnd' }}
                                                        </span>
                                                    </ng-container>

                                                </span>

                                                <ng-container *ngIf="(message.message || message.linkedItem) && !message.deleted_at">
                                                    <span class="message-content dont-break-out"
                                                          (click)="message.active = !message.active">
                                                        <ng-container *ngIf="message.linkedItem">
                                                            <ng-container [ngSwitch]="true">
                                                                <ng-container *ngSwitchCase="message.linkedItem.type == 'marketplace-post'">
                                                                    <h3 [ngClass]="{'clickable': message.linkedItem.clickable}"
                                                                        (click)="showMarketplacePostDetailFromLinked(message.linkedItem)">{{ 'MARKETPLACE_POST_REFERENCE_SUBJECT_PREFIX' | translate}}
                                                                        {{ message.linkedItem.text }}
                                                                    </h3>
                                                                </ng-container>
                                                                <ng-container *ngSwitchCase="message.linkedItem.type == 'group-call'">
                                                                    <h3 *ngIf="message.participant"
                                                                        [ngClass]="{'clickable': message.linkedItem.clickable}">
                                                                        {{ 'CHAT_GROUP_CALL_STARTED' | translate:{name: message.participant.getFullName()} }}
                                                                    </h3>
                                                                    <h3 *ngIf="!message.participant"
                                                                        [ngClass]="{'clickable': message.linkedItem.clickable}">
                                                                        {{ 'CHAT_GROUP_CALL_STARTED' | translate:{name: 'CHAT_GROUP_UNKNOW_SENDER' | translate} }}
                                                                    </h3>
                                                                </ng-container>
                                                            </ng-container>
                                                        </ng-container>
                                                        <span *ngIf="message.message"
                                                              [innerHtml]="message.message | striphtml:true | linkify | newline | safe:'html'">
                                                        </span>
                                                        <ng-container *ngIf="message.linkedItem">
                                                            <ng-container [ngSwitch]="true">
                                                                <ng-container *ngSwitchCase="message.linkedItem.type == 'group-call'">
                                                                    <ion-button *ngIf="message.linkedItem.clickable"
                                                                                (click)="openVideoCall();">
                                                                        {{ 'CHAT_GROUP_CALL_STARTED_BUTTON' | translate}}
                                                                    </ion-button>
                                                                </ng-container>
                                                            </ng-container>
                                                        </ng-container>
                                                    </span>
                                                </ng-container>

                                                <file-detail *ngIf="message.file && !message.deleted_at"
                                                             (click)="message.active = !message.active"
                                                             [file]="message.file">
                                                </file-detail>

                                            </div>

                                        </div>

                                    </div>

                                    <div class="end"></div>
                                </ng-container>
                            </div>

                            <div *ngIf="(selectedParticipant &&
                                    (user.canMessage(selectedParticipant) || conversation?.messages.length > 0) &&
                                    (!selectedParticipant.not_contactable && !user.selected_participant.not_contactable && !selectedParticipant.not_contactable_msg) &&
                                    (!selectedParticipant.invisible && !user.selected_participant.invisible)
                                ) || (selectedChatGroup && !user.selected_participant.invisible)"
                                 class="chat-box-form">

                                <dropzone [message]="''"
                                          [ngClass]="{'hidden': plt.is('cordova')}"
                                          [config]="dropZoneConfig">
                                </dropzone>

                                <ng-container *ngIf="plt.is('cordova')">
                                    <ion-button class="mobile-attachment"
                                                (click)="openMobileFileSelection()">
                                        <svg-icon [applyClass]="true"
                                                  class="fill-white"
                                                  slot="icon-only"
                                                  src="/assets/icons/messages/attachment.svg"></svg-icon>
                                    </ion-button>
                                </ng-container>

                                <ion-textarea rows="1"
                                              id="messages-textarea"
                                              ieTextareaFix
                                              [autoGrow]="true"
                                              (ionFocus)="messageBoxFocus()"
                                              (ionBlur)="plt.checkResize(false)"
                                              cols="20"
                                              (ionChange)="textareaChanged()"
                                              maxLength="10000"
                                              [(ngModel)]="messageValue"
                                              [placeholder]="'MESSAGES_NEW_MESSAGE_PLACEHOLDER' | translate">
                                </ion-textarea>

                                <ion-button *ngIf="!plt.sizeSm"
                                            [disabled]="submitting || !messageValue"
                                            [ngClass]="{disabled: !messageValue}"
                                            (click)="sendMessage()">
                                    <svg-icon *ngIf="!submitting"
                                              [applyClass]="true"
                                              class="fill-white"
                                              src="/assets/icons/ico-send.svg"></svg-icon>
                                    <ion-spinner *ngIf="submitting"
                                                 name="dots"></ion-spinner>
                                </ion-button>

                                <ion-button *ngIf="plt.sizeSm"
                                            class="mobile-send"
                                            (click)="sendMessage()">
                                    <svg-icon *ngIf="!submitting"
                                              [applyClass]="true"
                                              class="fill-white"
                                              src="/assets/icons/ico-send.svg"></svg-icon>
                                    <ion-spinner *ngIf="submitting"
                                                 name="dots"></ion-spinner>
                                </ion-button>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

            <div *ngIf="detailVisible"
                 class="details">
                <div *ngIf="!selectedParticipant || !plt.sizeSm"
                     class="details-header">
                    <h2>{{ 'CHAT_GROUPS_DETAILS' | translate }}</h2>
                    <a *ngIf="selectedChatGroup && !selectedChatGroup.stream && (!selectedChatGroup.appointment_id || selectedChatGroup.appointment?.past)"
                       class="leave"
                       (click)="leaveChatGroupConfirm(selectedChatGroup)">
                        {{ 'CHAT_GROUPS_LEAVE' | translate }}
                    </a>
                </div>
                <div class="details-box">
                    <div *ngIf="selectedParticipant"
                         class="attendee-detail">
                        <attendee-detail [attendeeId]="selectedParticipant.id"
                                         [smallPreview]="true"
                                         [hideHeader]="true"
                                         [silent]="true"
                                         class="in-messages"
                                         (onAppointmentRequest)="refresh()">
                        </attendee-detail>
                    </div>

                    <div *ngIf="selectedChatGroup && !selectedChatGroup.stream"
                         class="chat-group-detail">
                        <app-collapsible *ngIf="selectedChatGroup.description"
                                         [title]="'CHAT_GROUPS_ABOUT' | translate"
                                         [icon]="'hashtag'"
                                         [opened]="chatGroupdetails[0]"
                                         (boxOpened)="chatGroupDetailOpened(0)">
                            <ng-template let-item>
                                <div [innerHTML]="selectedChatGroup.description | linkify | securedImages | safe:'html'"></div>
                            </ng-template>
                        </app-collapsible>
                        <app-collapsible [title]="'CHAT_GROUPS_MEMBERS' | translate"
                                         [count]="chatGroupAttendeeCount"
                                         [icon]="'attendees'"
                                         [opened]="chatGroupdetails[1]"
                                         (boxOpened)="chatGroupDetailOpened(1)">
                            <ng-template let-item>
                                <div>
                                    <chat-group-attendees [chatGroup]="selectedChatGroup"
                                                          (onDetail)="showAttendeeDetail($event, false)"
                                                          (onDataLoaded)="chatGroupAttendeeCount=$event.total;chatGroupAttendees=$event.items">
                                    </chat-group-attendees>
                                </div>
                            </ng-template>
                        </app-collapsible>
                        <app-collapsible [title]="'CHAT_GROUPS_SETTINGS' | translate"
                                         [icon]="'settings'"
                                         [opened]="chatGroupdetails[2]"
                                         (boxOpened)="chatGroupDetailOpened(2)">
                            <ng-template let-item>
                                <div>
                                    <chat-group-settings [chatGroup]="selectedChatGroup"></chat-group-settings>
                                </div>
                            </ng-template>
                        </app-collapsible>
                        <app-collapsible *ngIf="user.selected_participant.is_owner"
                                         [title]="'CHAT_GROUPS_INVITED' | translate"
                                         [icon]="'attendees'"
                                         [opened]="chatGroupdetails[3]"
                                         (boxOpened)="chatGroupDetailOpened(3)">
                            <ng-template let-item>
                                <div>
                                    <chat-group-attendees [chatGroup]="selectedChatGroup"
                                                          [filterInvited]="true"
                                                          (onDetail)="showAttendeeDetail($event, false)">
                                    </chat-group-attendees>
                                </div>
                            </ng-template>
                        </app-collapsible>
                        <app-collapsible *ngIf="videoCallOpened"
                                         [title]="'CHAT_GROUPS_VIDEO_CALL_ATTENDEES' | translate"
                                         [count]="videoCallAttendees.length"
                                         [icon]="'attendees'"
                                         [opened]="chatGroupdetails[4]"
                                         (boxOpened)="chatGroupDetailOpened(4)">
                            <ng-template let-item>
                                <div>
                                    <video-call-attendees [items]="videoCallAttendees"
                                                          (onDetail)="showAttendeeDetail($event, false)">
                                    </video-call-attendees>
                                </div>
                            </ng-template>
                        </app-collapsible>
                    </div>

                    <div *ngIf="selectedBroadcast"
                         class="chat-group-detail">
                        <app-collapsible [title]="'CHAT_GROUPS_ABOUT' | translate"
                                         [icon]="'hashtag'"
                                         [opened]="true">
                            <ng-template let-item>
                                <div [innerHTML]="event.translate(event.default_locale).short_description | linkify | securedImages | safe:'html'"></div>
                            </ng-template>
                        </app-collapsible>
                    </div>
                </div>
            </div>
        </div>

        <ng-container *ngIf="(loading && !videoCallOpened) || !user || !event">
            <div class="content-centered-column">
                <div class="content-centered-row">
                    <ion-spinner></ion-spinner>
                </div>
            </div>
        </ng-container>

        <div *ngIf="!plt.tabMenu && (!loading && user && event) && !(selectedParticipant || selectedChatGroup || selectedBroadcast || addChatGroup)"
             class="content-centered-column">
            <div class="content-centered-row">
                <div class="empty-data">
                    <svg-icon [applyClass]="true"
                              src="/assets/icons/ico-messages.svg"
                              class="icon fill-light"></svg-icon>
                    <h3>{{ 'MESSAGES_EMPTY' | translate }}</h3>
                    <p (click)="goToAttendees()">
                        {{ 'MESSAGES_EMPTY_TEXT_1' | translate }}
                        <a class="pointer">{{ 'MESSAGES_EMPTY_TEXT_ANCHOR' | translate }}</a>
                        {{ 'MESSAGES_EMPTY_TEXT_2' | translate }}
                    </p>
                </div>
            </div>
        </div>
    </ng-container>
</ion-content>